export default __webpack_public_path__ + "static/media/info.b702d85e.svg";